module.exports = __webpack_public_path__ + "img/新闻快讯W.6c554d29.svg";